import mapboxgl from 'mapbox-gl'
import { ReactNode } from 'react'
import { createRoot } from 'react-dom/client'

export class CustomControl {
  map: mapboxgl.Map | undefined = undefined
  container: HTMLElement | undefined = undefined
  action: (a: boolean) => void
  visual: ReactNode
  className: string

  constructor(
    action: (a: boolean) => void,
    map: mapboxgl.Map | undefined = undefined,
    visual: ReactNode,
    className: string = 'custom-control'
  ) {
    this.map = map
    this.action = action
    this.visual = visual
    this.className = className
  }
  onAdd(map: mapboxgl.Map) {
    this.map = map

    this.container = document.createElement('div')
    this.container.className = this.className

    if (this.container)
      createRoot(this.container).render(
        <div
          onClick={() => {
            console.log('call action from control', this.action)
            this.action(true)
          }}
        >
          {this.visual}
        </div>
      )
    return this.container || document.createElement('div')
  }
  onRemove() {
    if (!this.container || !this.container.parentNode) return
    this.container.parentNode.removeChild(this.container)
    this.map = undefined
  }
}
